import { jsx as _jsx } from "react/jsx-runtime";
import { DeskPool } from '../../DeskPool';
import { ShootingPlayer } from '../../../molecules/ShootingPlayer';
export function Shooting() {
    const onPlayerClickAction = null;
    const gameButtonState = null;
    const getShootingPlayerChoice = () => _jsx(ShootingPlayer, {});
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState, addOnComponent: getShootingPlayerChoice }));
}
